import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { MethodSection } from '../components/MethodSection';
import { OfferSection } from '../components/OfferSection';
import { AudienceSection } from '../components/AudienceSection';
import { StepsSection } from '../components/StepsSection';
import { ProofSection } from '../components/ProofSection';
import { FaqSection } from '../components/FaqSection';
import { PriceBlock } from '../components/PriceBlock';
import { SalesFooter } from '../components/SalesFooter';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
  window.fbq('init', '2373451906450465');
  window.fbq('track', 'PageView');
}
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-brand-cream font-body selection:bg-brand-gold selection:text-brand-navy" data-id="element-200">
      <HeroSection data-id="element-201" />
      <PainSection data-id="element-202" />
      <MethodSection data-id="element-203" />
      <OfferSection data-id="element-204" />
      <AudienceSection data-id="element-205" />
      <StepsSection data-id="element-206" />
      <ProofSection data-id="element-207" />
      <FaqSection data-id="element-208" />
      <PriceBlock data-id="element-209" />
      <SalesFooter data-id="element-210" />
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-211">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2373451906450465&ev=PageView&noscript=1" alt="" data-id="element-212" />
      </noscript>
    </main>;
}